import css from './GSFullDescriptionModal.module.scss'
import React from 'react'

import { IGoodServiceTicketData, Tap2GOTicketTicketStatus } from 'meta/pages/goodsandservices'
import { Dates } from 'utils/dates'

import Img from 'components/Media/Img'
import BalloonBox from 'components/TextBoxes/BalloonBox'

type Props = {
  data: IGoodServiceTicketData
}

const GSFullDescriptionModal: React.FC<Props> = (props) => {
  const { data } = props

  const isCurrentDateInRange = Dates.isCurrentDateInRange(new Date(data.validFrom), new Date(data.validTo))
  const isTap2GoAvailable =
    data.status == Tap2GOTicketTicketStatus.valid && isCurrentDateInRange && data.hasVaultEnabled

  return (
    <div className={css.outer_wrapper}>
      <BalloonBox infoType={'info'} noPadding>
        <div className={css.wrapper}>
          <div className={css.ticketIcon}>
            {isTap2GoAvailable && <Img src="/goodsandservices/drink-icon.svg" />}
            {!isTap2GoAvailable && <Img src="/goodsandservices/drink-icon-error.svg" />}
          </div>

          <div className={css.header}>
            <div className={css.title}>{data.notes}</div>
            <div className={css.description}>{data.webDetails}</div>
          </div>
        </div>
      </BalloonBox>
    </div>
  )
}

export default GSFullDescriptionModal
